import { Grid } from "@mui/material";

import { ReactComponent as AssignUser } from "assets/AssignUser.svg";
import { clearSelectedCards, setActiveActionCard, setSelectedCards } from "components/app/App.slice";
import CheckBox from "components/common/Checkbox";
import Typography from "components/common/Typography";
import UserAvatarList from "components/common/UserAvatarList";
import StateDropDown from "components/common/dropdowns/StateDropDown";
import * as React from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { ABOVE_PROPERTY, accessTypes, statusTypes } from "utils/CommonConstants";
import { getUserHltId } from "utils/CommonFunctions";
import { getCardFormatDate } from "utils/DateHelper";
import { planTypes } from "utils/Types";
import { updateMyPlanCardDetailAsync } from "../MyPlanDetails/MyPlanDetails.slice";
import UpdateStatusConfirmDialog from "../planDetails/UpdateStatusConfirmationDialog";
import ActionCardDialogsContext from "./Context";
import Menu from "./Menu";
import "./MyPlans.scss";

interface Props {
  planId: number | undefined;
  dueDate: string;
  title: string;
  status: "New" | "In Progress" | "Completed";
  sectionId: number;
  cardId: number;
  assigneeList: any;
  multiCardSelect: boolean;
  item: any;
  isDisabled?: boolean;
}

function MyPlans(props: Props) {
  const dispatch = useAppDispatch();
  const {
    planId,
    dueDate,
    title,
    status,
    sectionId,
    cardId,
    assigneeList,
    multiCardSelect,
    item,
    isDisabled = false
  } = props;
  const cardList: any = useAppSelector((state) => state.app.selectedCards?.cardList);
  const selectedMyPlanDetail: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const { setIsOpenAssigneeDialog } = React.useContext(ActionCardDialogsContext);
  const isTemplatePlan = selectedMyPlanDetail.innCode === ABOVE_PROPERTY;
  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);
  const [updatedPayload, setUpdatedPayload] = React.useState<any>();
  const hltId: string = getUserHltId();
  const refStatus = React.useRef<any>();

  const findCheckedValueById = (idToFind: number, dataArray: any) => {
    const item = dataArray.find((item: any) => item.id === idToFind);
    return item ? item.checked : null;
  };
  const checked = findCheckedValueById(item.id, cardList);

  const handleChecked = () => {
    const dataCheck = cardList?.find((el: any) => el.id === item.id);

    if (!dataCheck) {
      const payload = {
        planId,
        sectionId,
        cardList: item
      };

      dispatch(setSelectedCards(payload));
    } else if (!checked && dataCheck) {
      dispatch(clearSelectedCards(item));
    }
  };

  const handleStatusChange = (val: any) => {
    if (item.status !== val) {
      const payload = {
        cards: [{ id: item?.id, status: val, dueDate: item?.dueDate || null }]
      };
      setUpdatedPayload(payload);
      const showConfirm = !item?.assignee?.includes(hltId);

      showConfirm
        ? setShowConfirmDialog(true)
        : dispatch(updateMyPlanCardDetailAsync({ url: `${planId}/sections/${sectionId}/cards`, payload }));
    }
  };
  const handleChangeUpdate = (val: any) => {
    const payload = updatedPayload;
    dispatch(updateMyPlanCardDetailAsync({ url: `${planId}/sections/${sectionId}/cards`, payload }));
  };
  const handleCloseDialog = () => {
    setShowConfirmDialog(false);
    refStatus?.current?.setValue(status);
  };

  return (
    <>
      <Grid sx={{ position: "relative", height: "100%" }}>
        <Grid item xs={12} display="flex">
          <Grid item xs={6} onClick={(e) => e.stopPropagation()}>
            {multiCardSelect ? (
              <CheckBox
                sx={{ marginLeft: "-12px", cursor: isDisabled && "default" }}
                checked={cardList?.some((el: any) => el.id === item.id)}
                onChange={() => {
                  if (!isDisabled) {
                    handleChecked();
                  }
                }}
              />
            ) : (
              <Typography variant="body2" color={tokens.Text.General.Secondary}>
                {getCardFormatDate(dueDate)}
              </Typography>
            )}
          </Grid>
          <Menu planId={planId} sectionId={sectionId} cardId={cardId} item={item} isDisabled={isDisabled} />
        </Grid>
        <Grid marginTop={3} marginBottom={2}>
          <Typography
            sx={{
              overflow: "hidden",
              minHeight: "63px",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "3",
              WebkitBoxOrient: "vertical"
            }}
            color={tokens.Text.General.PrimaryHeadline}
            variant="body2"
          >
            {title}
          </Typography>
        </Grid>
        {!isTemplatePlan && (
          <Grid container item alignItems={"center"}>
            <Grid item xs={6} display="flex" marginTop="4px" sx={{ paddingLeft: "8px" }} className="user-avatar-item">
              {assigneeList?.length ? (
                <UserAvatarList size="regular" users={assigneeList} max={3} />
              ) : (
                <Grid
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!isDisabled) {
                      dispatch(setActiveActionCard({ planId, planType: planTypes.MyPlans, sectionId, ...item }));
                      setIsOpenAssigneeDialog(true);
                    }
                  }}
                >
                  <AssignUser style={{ cursor: isDisabled ? "default" : "pointer" }} />
                </Grid>
              )}
            </Grid>

            {!multiCardSelect && (
              <Grid
                item
                xs={6}
                display="flex"
                justifyContent={"flex-end"}
                onClick={(e) => {
                  !isDisabled && e.stopPropagation();
                }}
                className="menu-options"
              >
                <StateDropDown
                  className="actionStatusChange-outside"
                  disabled={isDisabled}
                  name="status"
                  backgroundColor={tokens.Background.General.Secondary}
                  initialValue={status}
                  options={statusTypes}
                  handleChangeUpdate={handleStatusChange}
                  ref={refStatus}
                  accessType={accessTypes.update}
                />
              </Grid>
            )}
          </Grid>
        )}
        <UpdateStatusConfirmDialog
          open={showConfirmDialog}
          onConfirm={handleChangeUpdate}
          onClose={handleCloseDialog}
        />
      </Grid>
    </>
  );
}

export default MyPlans;
